import React, { useState } from 'react'
import { plansDefault } from '../common/plan'
import { useDispatch } from 'react-redux'
import { BsFillCheckCircleFill, BsQuestionLg, BsXCircleFill } from 'react-icons/bs';
import { Popover, ButtonToolbar, OverlayTrigger, Button } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom';
import FirstPlan from '../components/Plans/FirstPlan';
import SecondPlan from '../components/Plans/SecondPlan';
import ThirdPlan from '../components/Plans/ThirdPlan';
import Navbar from '../components/Navbar';
export default function Plans() {
    const [plans, setPlans] = useState(plansDefault)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const handleFirstPurchase = (price, planId, channelId, inde, credits) => {
        // if (activePlan?.index === inde) {
        navigate('/paymentPage', {
            state: { price: price, planId: planId, channelId: channelId, index: inde, credits: credits }
        })
        // }
        // else {
        //     dispatch({
        //         type: GLOBALTYPES.ALERT,
        //         payload: {
        //             error: 'Please Subscribe The Plan'
        //         }
        //     })
        // }
    }
    return (
        <div className=''>
            <Navbar />

            {/* <div className='mx-auto text-center   mb-4 font-extrabold leading-none tracking-tight text-purple-700 mt-10 sm:mt-12 text-2xl md:text-3xl lg:text-3xl'>

                <Link to='/'>Myzerome</Link>
            </div> */}
            <div className='lg:grid  lg:grid-cols-3 max-w-[1100px] gap-y-[20px] lg:gap-x-[20px] mx-auto lg:mt-[100px] '>
                <FirstPlan />
                <SecondPlan />
                <ThirdPlan />
            </div>


        </div >
    )
}
